import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";
import DarkBackground from '../../../Common/backgroundLoader';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'





var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
const Heading = [['Trip Id', 'Subsequent STO Number', 'PO Number',  'Warehouse',  'Client','Bill Number', 'Brand',  'Retailer Code',  'Item Code',  'MRP',  'Dispatch Quantity',  'Return Total', 'Return Good',  'Return Damage','Return Missing'  ,'SRN Date','Invoice No','Putaway Qty', 'Dues Qty','Gr push status','Gr Push Msg',
]];






class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchInventoryData = this.fetchInventoryData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      updateLoading: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      modalOpen: false,
      showRowDataError: false,
      isChecked: false,
      invalidItemList: [],
      selectedOption: null,
      success_icon: false,
      failed_icon: false,
      posts: [],
      ErrorRowData: [],
      AssignData: [],
      order_no: "",
      loading: false,

      isLoading: true,
      showFetchBinData: false,
      show_process_data: true,

      from_date: "",
      to_date: "",

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData :[],
    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  
  handleChange = (e)=>{
    this.setState({
      order_no: e.target.value,
    })
  }
  

  fetchInventoryData() {

    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    const payload = {
      order_no: this.state.order_no,
     
    };
    API.post('/utility/picker/pending/assignment/', { param: payload })
      .then(response => response.data)

      .then(data => {

        console.log(data);

        var AssignData = data.pending_assignment.map((item) => ({
          ...item,
          isChecked: false,
        }));
        this.setState({
           tableRows: this.assemblePosts(AssignData),
           AssignData: AssignData
          

        })

      })

      .then(async () => {

        this.setState({  isLoading: false })

       

      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };
  downloadReport = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      fromdate: From_Date_val,
      todate: to_Date_val,
      request_type: "download"
    };

    API.post('/reports/salesreturnreports/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loading: false
        });

        window.location.href = data.data[0]
      })
      .catch(function (error) { });
  };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      return (

        {
          action: <input style={{textAlign: 'center'}} type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={(index) => this.checkedSingle(index,post.isChecked, post.id)}/>,
          outlet_order_no: post.outlet_order_no,
          display_name: post.display_name,
          retailer_name: post.retailer_name,
        
         


        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      filtered_orderData : posts,
      orderData : posts,
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  toggleOpen = ()=> {
    this.setState((prevState) => ({ modalOpen: !prevState.modalOpen }));

  }

   toggleOK = ()=> {
    this.setState({
      modalOpen: false
    })

    this.fetchInventoryData();
    
  }

  checkAll() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
      });


      let newData = this.state.AssignData.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRows: this.assemblePosts(newData),
        AssignData: newData,
       
      });

    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
      });

      let newData = this.state.AssignData.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRows: this.assemblePosts(newData),
        AssignData: newData,
        //SelectedBins: newBinData,
      });

    }
  }

  checkedSingle(index, isChecked,id) {

      let newData1 = [...this.state.AssignData];

      // Find the item by id
      const itemIndex = newData1.findIndex(item => item.id === id);

      if (itemIndex !== -1) {
        // Toggle the isChecked value
        newData1[itemIndex].isChecked = !newData1[itemIndex].isChecked;
      } else {
        console.error("Item with the given ID not found!");
      }

      // Update the state with the modified data
      this.setState({
        tableRows: this.assemblePosts(newData1),
        AssignData: newData1,
      }); 
  }

  prioritizeData=()=>{
    this.setState({
      updateLoading: true
    })

    var arrayData = this.state.AssignData.filter(
      (item) => item.isChecked == true
    );
    var orderNo_arr = [];
    for (var i = 0; i < arrayData.length; i++) {
      orderNo_arr.push(arrayData[i].id);

    }

    console.log('orderNo_arr',orderNo_arr);

     const payload = {
      order_no: orderNo_arr,
      
    };

    API.post('/utility/picker/assignment/update/', { param: orderNo_arr })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          updateLoading: false
        });
        if(data.success == true){
          this.toggleOpen();
          this.setState({
            resp_message: data.message,
            success_icon: true,
            failed_icon: false
          })

        }else{
          this.toggleOpen();
          this.setState({
            resp_message: data.message,
            success_icon: false,
            failed_icon: true
          })


        }

      })
      .catch(function (error) { });


  }



  render() {

    const { modalOpen } = this.state;


    const data = {

      columns: [
        {
          label: <input type='checkbox' style={{position: 'absolute', bottom: '6%'}} checked={this.state.isChecked} onChange={() => this.checkAll()} />,

          field: "action",
          width: 50,
        },
        {
          label: 'Order No',
          field: 'outlet_order_no',
          sort: 'asc',
          width: 180,

        },
        {
          label: 'Display Name',
          field: 'display_name',
          sort: 'asc',
          width: 190,

        },
        {
          label: 'Retailer Name',
          field: 'retailer_name',
          sort: 'asc',
          width: 140,

        }

      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
        <Overlay>
              <form className="form">
                <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                  <span className="filter_title">Filters</span>
                </div>
                <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">Order Number</span>
                  <div style={{ position: 'relative' }}>
                    <input type="text" style={{ height: 38 }} className="form-control" placeholder="Order No." onChange={this.handleChange} />  
                  </div>
                </div>

               

             <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
              <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable1 "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                    marginRight: '10px',
                  }}
                  id="button_view"
                  onClick={() => this.fetchInventoryData()}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  View
                </Button>
             
                <Button
                  type="button"
                  className="btn btn-primary-outline"
                  style={{
                      cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                      backgroundColor: '#FFFFFF',
                      padding: "5px 10px",
                      color: '#333333', // Set text color
                      display: 'flex',   // Use flexbox to align image and text
                      alignItems: 'center' // Center items vertically
                  }}
                  id="button_download"
                   onClick={(e) => exportToCSV(this.state.filtered_orderData, "Sales Return Report", Heading)}>
                  <img
                      src={DownloadIcon}
                      alt="Download"
                      style={{ width: '22px' }} // Adjust size as needed
                  />
                  Download
                </Button>
              </ButtonToolbar>
            </div>

          </form>
          </Overlay>
          {!this.state.showFetchBinData && (
            <div style={{width: '80%', textAlign: 'center', padding: '12%'}}>
               <img style={{width: '10%'}} src={EmptyDataIcon} />
                <p className="noDataTextStyle">
                Choose your filters from the available options. The data will display
              </p>
              <p className="noDataTextStyle2">
                 here once the filters have been applied.
              </p>
            </div>
          )}

          {
            this.state.showFetchBinData && (

                <div>
                 <Button
                  className="btn-sm button_enable1 "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                    marginRight: '10px',
                  }}
                  id="button_view"
                  onClick={() => this.prioritizeData()}
                >
                  {this.state.updateLoading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Update
                </Button>
              <div>
                {this.state.order_no &&
                <div className="date-container1">
                 {this.state.order_no}
                </div>
                }



              </div>
            <div style={{ marginTop: '4%', paddingTop: 20, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
                <span
                    className="pull-right"
                    onClick={() => this.fetchInventoryData()}
                    style={{
                      fontSize: "17px",
                      paddingRight: "45px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "18px",
                    }}
                  >
                    <FontAwesomeIcon icon={faSyncAlt}></FontAwesomeIcon>
                  </span>
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  displayEntries= {false}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'Sales Return Report', 'datatable_pagination_change' )}
                  hover
                  onSearch={this.filterData}
                   paging= {false}
                  data={data}
                  // style={{ textAlign: "center" }}
                />
             </div>
            </div>
            </div>

            )}

        </Card>

       <Modal isOpen={modalOpen} backdrop="static" toggle={this.toggleOpen}>
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            style={{ right: 15 }}
            onClick={this.toggle}
          />
        </div>
        <div
          className="modal__body"
          style={{ paddingTop: 55, paddingBottom: 20 }}
        >

          {this.state.success_icon &&
          <span
            className="lnr lnr-thumbs-up modal__title-icon"
            style={{ color: "#4ce1b6" }}
          />
        }
        {this.state.failed_icon &&
          <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
        }
          <h4>{this.state.resp_message} </h4>
        </div>
        <ButtonToolbar className="modal__footer">
          <Button
            style={{ backgroundColor: "#24d6a3", color: "#fff" }}
            className="modal_ok"
            onClick={this.toggleOK}
          >
            Ok
          </Button>
        </ButtonToolbar>
        </Modal>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));